import React from 'react';

import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import styles from '../__styles__/overviewTable.scss?modules';

const HowYouEarn = ({ content }) => {
  if (!Array.isArray(content)) return null;
  return (
    <div>
      {content.map(({ header, description }, i) => (
        <div key={i}>
          {header && (
            <Sanitizer
              className={styles.howToEarnHeader}
              safelySetInnerHTML={header}
            />
          )}
          {description && <Sanitizer safelySetInnerHTML={description} />}
          {i !== content.length - 1 && (
            <>
              <br />
              <br />
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default HowYouEarn;
